<template>
    <div>
        <keen-message-address-input
            v-model="message.to"
            :disabled="isSending||disabled"
            v-if="!replyMode&&!hideToField"
            query-mode="phone"
        />

        <ui-textbox
            ref="content"
            v-model="message.content"
            placeholder="Enter your message..."
            multi-line
            :rows="4"
            :maxlength="1000"
            enforce-maxlength
            :disabled="disabled"
        />

        <composer-attachment-pane
            :style="replyMode ? 'margin: 1rem 0;' : 'margin: 1rem 0 2rem;'"
            v-model="message.attachments"
        ></composer-attachment-pane>

        <div class="row" style="margin-top: 1rem;">
            <div class="col">
                <message-box-dropdown-selector
                    v-model="message.message_box"
                    :disabled="isSending||disabled"
                    v-if="!replyMode"
                />
                <ui-icon-button
                    type="secondary"
                    icon="delete"
                    :disabled="isSending||disabled"
                    @click="$emit('reset')"
                    v-if="replyMode"
                />
            </div>
            <div class="col-8 text-right">
                <div class="ui-select-horizontal">
                    <ui-select
                        label="Status:"
                        v-model="assignStatus"
                        :options="statusList"
                        style="margin-bottom: 0;"
                    ></ui-select>
                </div>
                <ui-button
                    icon="send"
                    color="primary"
                    :loading="isSending"
                    :disabled="disabled"
                    @click="send"
                >Send</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    import KeenMessageAddressInput from "./KeenMessageAddressInput";
    import MessageBoxDropdownSelector from "./MessageBoxDropdownSelector";
    import ComposePaneBase from "./ComposePaneBase";
    import {MessageTypes} from "../../classes/Api/Inbox";
    import ComposerAttachmentPane from "./ComposerAttachmentPane";

    export default {
        components: { KeenMessageAddressInput, MessageBoxDropdownSelector, ComposerAttachmentPane },
        extends: ComposePaneBase,
        created() {
            this.message.content = this.defaultContent
        },
        mounted() {
            this.focus()
        },
        methods: {
            onReset() {
                this.message.content = this.defaultContent

                this.focus()
            },
            focus() {
                if (this.$refs.content) {
                    this.$refs.content.focus()
                    this.$nextTick(() => {
                        if (this.$refs.content && this.$refs.content.$refs.textarea) {
                            this.$refs.content.$refs.textarea.selectionStart = 0
                            this.$refs.content.$refs.textarea.selectionEnd = 0
                        }
                    })
                }
            }
        },
        computed: {
            defaultContent() {
                return window.marque.ui.signatures.txt
            },
            messageMedium() {
                return MessageTypes.TYPE_TEXT
            },
            messageRecipients() {
                return this.message.to.primary_telephone ?
                    this.message.to.primary_telephone : this.message.to.primary_display_as
            }
        }
    }
</script>

<style scoped>

</style>